import type { MaybeRefOrGetter, Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IWellKnownLinksListRecord } from '../types';
import { WELL_KNOWN_LINKS_LIST_API_URL, WELL_KNOWN_LINKS_LIST_QUERY_KEY, WELL_KNOWN_LINKS_PERMISSIONS } from '../constants';

export default function useWellKnownLinksListQuery(tableState: Ref<ITableState>, enabled: MaybeRefOrGetter<boolean>): IContextQueryResult<
  ITableDataResponse<IWellKnownLinksListRecord>
> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IWellKnownLinksListRecord>>({
    queryKey: [WELL_KNOWN_LINKS_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IWellKnownLinksListRecord>>(
      WELL_KNOWN_LINKS_LIST_API_URL,
      tableState.value,
      {
        signal,
        permission: WELL_KNOWN_LINKS_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
    enabled,
  });
}
